import React from 'react';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@biq/apex-ui';
import CodeMirror from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';
import { CodeMirrorStyles, validationsMessages } from 'lib';
import {
    commonStyles,
    PipelinesCodeMirrorStyles,
} from 'pages/pipelines/pipelines-helper';
import {
    TrialRunJsonDataEditorProps,
    trialRunModalStyles,
} from './trial-run-modal-helper';

export const TrialRunJsonDataEditor = ({
    control,
    value,
    errors,
    readOnlyEditor,
    onEditorValueChange,
    codeMirrorHeight = '377px',
}: TrialRunJsonDataEditorProps): React.JSX.Element => {
    return (
        <Box sx={trialRunModalStyles.codeMirrorFieldStyles}>
            <Controller
                name='data'
                control={control}
                render={(): React.JSX.Element => (
                    <>
                        <CodeMirror
                            value={value}
                            readOnly={readOnlyEditor}
                            style={{
                                ...commonStyles.codeMirrorConatiner,
                                ...(errors ? commonStyles.codeMirrorError : {}),
                            }}
                            height={codeMirrorHeight}
                            extensions={[
                                CodeMirrorStyles,
                                PipelinesCodeMirrorStyles,
                                json(),
                            ]}
                            onChange={onEditorValueChange}
                        />
                        {errors && (
                            <Box pt={0.25}>
                                <ErrorMessage
                                    errorMessage={validationsMessages.required}
                                />
                            </Box>
                        )}
                    </>
                )}
            />
        </Box>
    );
};
